<template>
  <div class="main">
    <label class="flex-col-fJstart-fAstart main-input">
      Nom de la sélection*
      <input
        type="text"
        v-model="currentModele.nom"
      >
    </label>

    <div class="main-input">
      <label class="flex-col-fJstart-fAstart">
        Sélection
      </label>
      <div class="selection-familles">
        <div class="selectionneur-familles">
          <label class="flex-col-fJstart-fAstart selectionneur-familles">
            <input
              type="checkbox"
              :checked="includeArticles"
              @change="setIncludeArticles"
            >
            Afficher les articles
          </label>
          <PlanVenteTree
            @planVenteClicked="clickPlanVenteSelectionModele"
          />
        </div>
        <div class="selected-familles">
          <span class="selected-familles__title">VOTRE SELECTION</span>
          <ul class="selected-familles__list">
            <li
              v-for="famille of currentModele.selection.famille"
              :key="famille.code"
              class="selected-familles__list__item"
            >
              <span class="selected-familles__article__text">{{ famille.libelle }}</span>
              <FontAwesomeIcon
                icon="times"
                size="1x"
                class="selected-familles__delete"
                style="color: #333333;"
                @click="clickPlanVenteSelectionModele(famille)"
              />
            </li>
            <li
              v-for="article of currentModele.selection.article"
              :key="article.code"
              class="selected-familles__list__item"
            >
              <span class="selected-familles__article__text">{{ article.libelle }}</span>
              <FontAwesomeIcon
                icon="times"
                size="1x"
                class="selected-familles__delete"
                style="color: #333333;"
                @click="clickPlanVenteSelectionModele(article)"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="flex-fJend-fAcenter">
      <FontAwesomeIcon
        icon="spinner"
        size="2x"
        v-if="validating"
        class="loader"
        spin
      />
      <div v-if="!validating">
        <button
          v-if="currentModele.id != null"
          class="modele_supprimer"
          @click="suppression"
        >
          Suppression du modèle
        </button>
        <button
          class="modele_cancel"
          @click="cleanUp"
        >
          Annuler
        </button>
        <button
          class="modele_validate"
          @click="accepter"
        >
          Ok
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PlanVenteTree from './planVente/PlanVenteTree'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: { PlanVenteTree },
  computed: {
    ...mapGetters([
      'currentModele',
      'includeArticles'
    ])
  },
  data: function () {
    return {
      validating: 0
    }
  },
  methods: {
    ...mapActions([
      'clickPlanVenteSelectionModele',
      'suppressionModele',
      'setIncludeArticles'
    ]),
    cleanUp() {
      this.$store.dispatch('resetCurrentModele')
      this.$emit('close')
      this.validating = 0
    },
    suppression(id) {
      this.validating = 1
      this.suppressionModele(id).then(() => {
        this.cleanUp()
      })
    },
    accepter() {
      if (this.currentModele.nom === '') {
        Vue.toasted.error('Veuillez spécifier le nom de la sélection').goAway(1500)
      } else {
        this.validating = 1
        this.$store.dispatch('validationModele').then(() => {
          this.cleanUp()
        })
      }
    }
  }
}
</script>

<style scoped>

.main {
  padding: 0 -1rem;
}

.selection-familles {
  display: flex;
  flex: 1;
  padding: 0 -1rem;
}

.selected-familles {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.selected-familles__title {
  align-self: center;
  margin-bottom: 1em;
  font-weight: bold;
}

.selected-familles__list {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  cursor: default;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.selected-familles__list__item {
  display: flex;
  align-items: center;
  min-height: 25px;
  justify-content: center;
  width: 90%;
}

.selected-familles__article__text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.selected-familles__delete {
  margin-left: 0.5em;
  cursor: pointer;
}

.selectionneur-familles {
  display: inline-block;
}

.main-input {
  margin-bottom: 1em;
}

button {
  padding: 2px 12px;
  margin-left: 10px;
  font-size: 18px;
  font-weight: 400;
  border-radius: 0;
  cursor: pointer;
  border: 0.1rem solid transparent;
  background-color: #f18731;
  color: #ffffff;
}
button:hover {
  background-color: #3b3b3b;
  color: #f18731;
}

.modal__cancel {
  background-color: #3b3b3b;
  color: #ffffff;
}
.modal__cancel:hover {
  background-color: #3b3b3b;
  color: #f18731;
}
.modal__cancel:focus {
  background-color: #3b3b3b;
  color: #f18731;
}

.modal__validate {
  background-color: #f18731;
  color: #ffffff;
}
.modal__validate:hover {
  background-color: #3b3b3b;
  color: #f18731;
}
.modal__validate:focus {
  background-color: #3b3b3b;
  color: #f18731;
}
</style>
